// @ts-check 
import * as React from 'react';
import Typography from '@mui/material/Typography';
import MyText from '../../controls/MyText';
import { useState } from 'react';
import MyAlert from '../../controls/MyAlert';
import { enumPage, enumTaskPhase } from '../../helpers/common.constants';
import Button from '@mui/material/Button';
import { Grid } from '@mui/material';
import { useParams, useLocation, useNavigate } from "react-router-dom";
import moment from 'moment';
import { MessageHelper } from '../../helpers/MessageHelper';
import DeclarationActions from '../../actions/DeclarationActions';
import TaskActions from '../../actions/TaskActions';
import Link from "@mui/material/Link";
import DocumentActions from '../../actions/DocumentActions';

const RecordDefault = {
  // Main task properties
  mtTaskID: 0,
  mtTaskTemplateID: 0,
  mtEntityID: 0,
  mtEntityRowID: 0,
  mtActiveFL: false,
  mtTaskTypeID: 0,
  mtTaskFlowVerifierID: 0,
  mtTaskFlowApprovalID: 0,
  mtTaskName: "",
  mtTaskNote: "",
  mtTaskCreatedDate: moment().format("YYYY-MM-DD"),
  mtTaskDueDate: moment().format("YYYY-MM-DD"),
  mtTaskVerifierDueDate: moment().format("YYYY-MM-DD"),
  mtTaskTotalVerifiers: 0,
  mtTaskApporverDueDate: moment().format("YYYY-MM-DD"),
  mtTaskTotalApprovers: 0,
  mtTaskTotalPhases: 0,
  mtTaskCurrentPhase: 0,
  mtCreatorFL: false,
  mtCreatorStaffID: 0,
  mtCreatorFullName: "",
  mtCreatorEmail: "",
  mtCreatorGoogleDocFileID1: "",
  mtCreatorGoogleDocName1: "",
  mtCreatorGoogleDocFileID2: "",
  mtCreatorGoogleDocName2: "",
  mtGoogleFolderID: "",
  mtTaskMandatoryTotalFiles: 0,
  mtTaskMandatoryFileCaption1: "",
  mtTaskMandatoryGoogleDocFileID1: "",
  mtTaskMandatoryGoogleDocName1: "",
  mtTaskMandatoryFileCaption2: "",
  mtTaskMandatoryGoogleDocFileID2: "",
  mtTaskMandatoryGoogleDocName2: "",
  mtTaskOptionalTotalFiles: 0,
  mtTaskOptionalFileCaption1: "",
  mtTaskOptionalGoogleDocFileID1: "",
  mtTaskOptionalGoogleDocName1: "",
  mtTaskOptionalFileCaption2: "",
  mtTaskOptionalGoogleDocFileID2: "",
  mtTaskOptionalGoogleDocName2: "",

  // Verifier 1–4
  mtnVerifierID1: 0,
  mtnVerifierName1: "",
  mtnVerifierEmail1: "",
  mtnVerifierNote1: "",
  mtnVerifierApprovedFL1: null,
  mtnVerifierDate1: null,
  mtnVerifierCaption1: "",

  mtnVerifierID2: 0,
  mtnVerifierName2: "",
  mtnVerifierEmail2: "",
  mtnVerifierNote2: "",
  mtnVerifierApprovedFL2: null,
  mtnVerifierDate2: null,
  mtnVerifierCaption2: "",

  mtnVerifierID3: 0,
  mtnVerifierName3: "",
  mtnVerifierEmail3: "",
  mtnVerifierNote3: "",
  mtnVerifierApprovedFL3: null,
  mtnVerifierDate3: null,
  mtnVerifierCaption3: "",

  mtnVerifierID4: 0,
  mtnVerifierName4: "",
  mtnVerifierEmail4: "",
  mtnVerifierNote4: "",
  mtnVerifierApprovedFL4: null,
  mtnVerifierDate4: null,
  mtnVerifierCaption4: "",

  // Approver 1–4
  mtnApproverID1: 0,
  mtnApproverName1: "",
  mtnApproverEmail1: "",
  mtnApproverNote1: "",
  mtnApproverApprovedFL1: null,
  mtnApproverDate1: null,
  mtnApproverCaption1: "",

  mtnApproverID2: 0,
  mtnApproverName2: "",
  mtnApproverEmail2: "",
  mtnApproverNote2: "",
  mtnApproverApprovedFL2: null,
  mtnApproverDate2: null,
  mtnApproverCaption2: "",

  mtnApproverID3: 0,
  mtnApproverName3: "",
  mtnApproverEmail3: "",
  mtnApproverNote3: "",
  mtnApproverApprovedFL3: null,
  mtnApproverDate3: null,
  mtnApproverCaption3: "",

  mtnApproverID4: 0,
  mtnApproverName4: "",
  mtnApproverEmail4: "",
  mtnApproverNote4: "",
  mtnApproverApprovedFL4: null,
  mtnApproverDate4: null,
  mtnApproverCaption4: "",
  Note:""
}



export default function TaskVerify() {


  const [TaskData, setTask] = useState(RecordDefault);
  const [Record, setRecord] = useState(RecordDefault);
  const [EnableButtons, setEnableButtons] = useState(true);
  const [IsFinanceApproval, setFinanceApproval] = useState(false);
  const [IsBudgetHolderApproval, setBudgetHolderApproval] = useState(false);
  const [MessageData, setMessageData] = useState({});
  const [CostRecords, setCostRecords] = useState([]);
  const [PerDiemRecords, setPerDiemRecords] = useState([]);
  const { TaskID, TaskNoteID, showMsg } = useParams();
  const [IsInitDone, setIsInitDone] = useState(false);
  const [ForceSave, setForceSave] = useState(false);
  const [SumRecord, setSumRecord] = useState([]);

  //za Navigacija 
  const navigate = useNavigate();

  //za poraki pri loadiranje na strana 
  const msgHelper = new MessageHelper();

  //Za Refreshiranje na strana mu treba;
  const location = useLocation();

  //****************************************** */
  //HOOKS SECTION HERE 
  //****************************************** */

  //1 --> Iniicijalno povikaj initData i ako zavrsi se kako sto treba ke go setira IsInitDone: true koj sto ke go zapali hook-ot IsInitDone
  React.useEffect(() => {
    initData();
  }, [location.pathname + '/' + location.search]);

  //****************************************** */
  //METHOD  SECTION HERE 
  //****************************************** */

  const initData = () => {
    async function fetchData() {

      let result = msgHelper.setPhase(enumPage.LoadStart);
      setMessageData(result);  

      let payload = { mtTaskID: TaskID };
      let responses = await new TaskActions().EditWithCheckAsync(payload); // await LookupActions.InitAsync();
      if (!responses.error) {

        let recordDb = responses[0].data;
        setTask(recordDb); 

        setEnableButtons(!(TaskData.mtTaskCurrentPhase == enumTaskPhase.Closed));
        
        if (recordDb.mtTaskCurrentPhase === enumTaskPhase.Closed) {
          let result = msgHelper.setPhase(enumPage.LoadSuccessWithWarningMsg, null, "Task is closed");
          setMessageData(result);
        } 
        else {
          let result = msgHelper.setPhase(enumPage.LoadSuccess);
          setMessageData(result);  
        }
        
      }
      else {
        let result = msgHelper.setPhase(enumPage.ErrorServer, responses);
        setMessageData(result);
        setEnableButtons(true);
      }

    }
    fetchData();
  };

  
  const approveData = () => {

    async function fetchData() {

      //Load Start
      let result = msgHelper.setPhase(enumPage.LoadStart);
      setMessageData(result);

      TaskData.Approved = true;
      TaskData.TaskNoteID = TaskNoteID;
      TaskData.Note  = Record.Note; 


      let isVerify = location.pathname.toLowerCase().toString().indexOf("verify".toLowerCase()) > -1;
      let response = null;
      if (isVerify)
      {
        response = await new TaskActions().VerifierAnswerAsync(TaskData);
      }
      else {
         response = await new TaskActions().ApproverAnswerAsync(TaskData);
      }
      

      if (!response.error) {

        let recordDb = response[0].data;
        setRecord(recordDb);

        if (recordDb.mtTaskCurrentPhase == enumTaskPhase.Closed)
        {
          result = msgHelper.setPhase(enumPage.LoadSuccessWithMsg, null, "Task is closed");
        }
        else if (isVerify)
        {
          result = msgHelper.setPhase(enumPage.LoadSuccessWithMsg, null, "Task verified");
        }
        else {
          result = msgHelper.setPhase(enumPage.LoadSuccessWithMsg, null, "Task approved");
        }

        setEnableButtons(false);

        setMessageData(result);
        setRecord((a) => ({ ...a, ValidationMessages: result.ValidationMessages }));  //Ako ima Validation Messages da gi izbrise
      }
      else {
        //Finished  with Error
        result = msgHelper.setPhase(enumPage.ErrorServer, response);
        setMessageData(result);
        setRecord((a) => ({ ...a, ValidationMessages: result.ValidationMessages }));  //Samo ovdeka mu treba ako ima Validacioni greski da dodade
      }
    }

    fetchData();
  };


  const disapproveData  = () => {

    async function fetchData() {

      //Load Start
      let result = msgHelper.setPhase(enumPage.LoadStart);
      setMessageData(result);

      TaskData.Approved = false;
      TaskData.TaskNoteID = TaskNoteID;
      TaskData.Note  = Record.Note; 
      
      let isVerify = location.pathname.toLowerCase().toString().indexOf("verify".toLowerCase()) > -1;
      let response = null;
      if (isVerify)
      {
        response = await new TaskActions().VerifierAnswerAsync(TaskData);
      }
      else {
         response = await new TaskActions().ApproverAnswerAsync(TaskData);
      }



      if (!response.error) {

        let recordDb = response[0].data;
        setRecord(recordDb);

        result = msgHelper.setPhase(enumPage.LoadSuccessWithMsg, null, "Task disapproved");

        setEnableButtons(false);

        setMessageData(result);
        setRecord((a) => ({ ...a, ValidationMessages: result.ValidationMessages }));  //Ako ima Validation Messages da gi izbrise
      }
      else {
        //Finished  with Error
        result = msgHelper.setPhase(enumPage.ErrorServer, response);
        setMessageData(result);
        setRecord((a) => ({ ...a, ValidationMessages: result.ValidationMessages }));  //Samo ovdeka mu treba ako ima Validacioni greski da dodade
      }
    }

    fetchData();
  };

  

  //****************************************** */
  //HANDLERS SECTION HERE 
  //****************************************** */
  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(name + ":" + value);
    setRecord((prevState) => ({ ...prevState, [name]: value }));
  };



  //****************************************** */
  //GUI DISPLAY
  //****************************************** */
  const ActionButtons = () => {
    return (
      <Grid container padding={1}>
        <Grid item xs={6} align="left">
          <Button name="btnSave" variant="contained" color="secondary" size="small" disabled={MessageData.Loading || !EnableButtons} onClick={() => disapproveData()}>Disapprove</Button>
        </Grid>

        <Grid item xs={6} align="right">
          <Button name="btnSave" variant="contained" color="success" size="small" disabled={MessageData.Loading || !EnableButtons} onClick={() => approveData()}>Approve</Button>
        </Grid>
      </Grid>
    )
  };

  const HeaderButtons = () => {
    return (
      <Grid container sx={{ borderBottom: 1, borderColor: 'grey.500', pb: 1 }}>
        {/* <Grid item xs={12} align="right">
          <Button name="btnDownload" variant="contained" color="warning" size="small" disabled={MessageData.Loading} onClick={() => downloadDeclaration()}>Download</Button>
        </Grid> */}

      </Grid>
    )
  };

const downloadFile = (fileName, fileId) => {
      async function fetchData() {
        let payload = "/" + fileId;
        let response = await new DocumentActions().DownloadFileAsync(payload);
  
        // create file link in browser's memory
        const href = URL.createObjectURL(response.data);
  
        // create "a" HTML element with href to file & click
        const link = document.createElement("a");
        link.href = href;
        link.setAttribute("download", fileName); //or any other extension
        document.body.appendChild(link);
        link.click();
  
        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
      }
      fetchData();
    };

  return (
    <Typography sx={{ my: 5, mx: 2 }} color="text.secondary" align="left">

      <MyAlert {...MessageData} />


      <Grid container align="center">
        <Grid item xs={12}>
          <Typography variant="h3" display="block">Task: {TaskData.mtTaskName}
              {TaskData.mtTaskCurrentPhase == enumTaskPhase.Closed ? " (Status:" + TaskData.Status + ")" : ""}
            </Typography> 
        </Grid>
      </Grid>


      <HeaderButtons />

      <Grid container>


      <Grid container align="left" sx={{ pb: 1, fontSize:14, borderBottom: 1, borderColor: 'grey.500' }}>
        <Grid item xs={2}>
            <b>Description:</b>
        </Grid>
        <Grid item xs={10}>
          {TaskData.mtTaskNote}
        </Grid>
      </Grid>

       <Grid container align="left" sx={{ pb: 1, fontSize:14 }}>
        <Grid item xs={2}>
            <b>Date Created:</b>
        </Grid>
        <Grid item xs={10}>
          {moment(TaskData.mtTaskCreatedDate).format("DD/MM/YYYY")}
        </Grid>
      </Grid>


       <Grid container align="left" sx={{ pb: 1, fontSize:14 }}>
        <Grid item xs={2}>
            <b>Task Due Date:</b>
        </Grid>
        <Grid item xs={10}>
          {moment(TaskData.mtTaskDueDate).format("DD/MM/YYYY")}
        </Grid>
      </Grid>

      <Grid container align="left" sx={{ pb: 1, fontSize:14 }}>
        <Grid item xs={2}>
            <b>Verification Due Date:</b>
        </Grid>
        <Grid item xs={10}>
          {moment(TaskData.mtTaskVerifierDueDate).format("DD/MM/YYYY")}
        </Grid>
      </Grid>
 
      <Grid container align="left" sx={{ pb: 2, fontSize:14, borderBottom: 1, borderColor: 'grey.500' }}>
        <Grid item xs={2}>
            <b>Approver Due Date:</b>
        </Grid>
        <Grid item xs={10}>
          {moment(TaskData.mtTaskApporverDueDate).format("DD/MM/YYYY")}
        </Grid>
      </Grid>

      <Grid container align="left" sx={{ fontSize:14 }}>
        <Grid item xs={2}>
            <b>Verifier Flow:</b>
        </Grid>
        <Grid item xs={10}>
          {TaskData.TaskFlowVerifierTitle}<br/>
          {TaskData.TaskWorkFlowVerifiers} 
        </Grid>
      </Grid>
       

      <Grid container align="left" sx={{ fontSize:14}}>
        <Grid item xs={2}>
            <b>Approver Flow:</b>
        </Grid>
        <Grid item xs={10}>
          {TaskData.TaskFlowApproverTitle}<br/>
          {TaskData.TaskWorkFlowApprovers} 
        </Grid>
      </Grid>


      <Grid container align="left" sx={{ pt:2, pb: 3, fontSize:14, borderTop: 1, borderColor: 'grey.500' }}>
        <Grid item xs={2}>
            <b>Linked Documents:</b>
        </Grid>
        
        <Grid item xs={10}>
 
            {TaskData.mtCreatorGoogleDocName1 != ""  ?  
            <Link
                  onClick={() => downloadFile(TaskData.mtCreatorGoogleDocName1, TaskData.mtCreatorGoogleDocFileID1)}
                  href="#" 
                  rel="noopener noreferrer"
                  sx={{ mr: 20 }}
                >
                  {TaskData.mtCreatorGoogleDocName1} 
            </Link>
            :
            ""} 


            {TaskData.mtCreatorGoogleDocName2 != ""  ?  
            <Link
                  onClick={() => downloadFile(TaskData.mtCreatorGoogleDocName2, TaskData.mtCreatorGoogleDocFileID2)}
                  href="#" 
                  rel="noopener noreferrer"
                >
                  {TaskData.mtCreatorGoogleDocName2} 
            </Link>
            :
            ""}       
        </Grid>
      </Grid>


      </Grid>

      <Grid container align="left" sx={{ borderBottom: 1, borderColor: 'grey.500', pb: 1, fontSize:14 }}>
        <Grid item xs={12}>
            <b>Notes</b>
        </Grid>
      </Grid>


      <Grid container align="left" sx={{ fontSize:14 }}>
        <Grid item xs={12}>
          <div
              dangerouslySetInnerHTML={{ __html: TaskData.TaskNotes }}
            />
        </Grid>
      </Grid>



      <Grid container>
        <Grid item xs={12}>
          <MyText Id='Note'
            PlaceHolder='Please enter notes'
            Record={Record}
            HandleChange={handleChange}
            ValidationMessages={Record.ValidationMessages}
            MultiLine={true}
            Rows={3}
          />
        </Grid>
      </Grid>

      <ActionButtons />
      <MyAlert {...MessageData} />
    </Typography>
  );
}
